import React from "react";
import { Headline } from "../GenericComponents/Headline";

export interface FaqPageContainerProps {
  history: any;
}

export interface FaqPageContainerState {}

class FaqContainer extends React.Component<
  FaqPageContainerProps,
  FaqPageContainerState
> {
  componentDidMount() {}

  render() {
    return (
      <div className="informational-page">
        <Headline history={this.props.history} />
        <div className="informational-content">
          <h1>Frequently Asked Questions (FAQs)</h1>
          <h2>How do I obtain and analyse the results?</h2>
          The results of your analysis are saved for six months on our webserver, where you can access them with the result link for analysis. Please make sure to copy the link provided after you submit the job to the server. After successful analysis, you can download all scores and tables as human readable csv-files, which you can analyse, filter, and store as you like.
          <hr></hr>
          <h2>Can I analyse a protein for which more than two structures are available?</h2>
          The labelizer algorithm currently only supports the comparison of two conformations of a protein. If you have more information available (A, B, C), you can run two separate analysis requests (A&B and B&C) and combine the resulting tables in the csv-files to filter the results according to your needs.
          <hr></hr>
          <h2>How do I obtain optimal FRET pairs that have no distance change comparing two protein conformations?</h2>
          We do not provide a specific score for this type of request. But the resulting tables can be filtered for protein variants without any (or very minor) distance changes. Compare the design and description of the MalE variant 84/352 (Supplementary Figure 12 <a href="https://static-content.springer.com/esm/art%3A10.1038%2Fs41467-025-58602-y/MediaObjects/41467_2025_58602_MOESM1_ESM.pdf" target="_blank" rel="noopener noreferrer">PDF</a>) in the labelizer paper <a href="https://www.nature.com/articles/s41467-025-58602-y" target="_blank" rel="noopener noreferrer">(Link)</a>.
          <hr></hr>
          <h2>Can I increase the number of refined pairs?</h2>
          We do not support a number higher than 300 for the calculation of refined pairs to reduce the computational load. You can increase the refinement and further adapt the analysis by the direct use of the labelizer python package <a href="https://github.com/ChristianGebhardt/labelizer" target="_blank" rel="noopener noreferrer">https://github.com/ChristianGebhardt/labelizer</a>. Alternatively, you can get in touch with us directly if you want to discuss specific requests (see the Feedback <a href="https://labelizer.org/feedback" target="_blank" rel="noopener noreferrer">https://labelizer.org/feedback</a> section).
          <hr></hr>
          <h2>Are there updates and new features planned?</h2>
          We plan to improve our prediction and update the available services in the future. If you have any specific suggestions, do not hesitate to get in touch with us.
          <hr></hr>
          <h2>How can I get in touch directly to discuss problems or results?</h2>
          We appreciate any feedback or suggestion for improvement regarding our webserver and the algorithm. Please, send a mail to <a href="mailto:thorben.cordes@tu-dortmund.de">thorben.cordes@tu-dortmund.de</a> &amp; <a href="mailto:thomas.peulen@tu-dortmund.de">thomas.peulen@tu-dortmund.de</a>.
          <hr></hr>
        </div>
      </div>
    );
  }
}

export default FaqContainer;
